import * as THREE from 'three';
import BaseMesh from './base-mesh';
class Image extends BaseMesh {
    constructor(data) {
        super(data);
        this.update(data, true);
    }
    update(data, isInit = false) {
        const { visible = true, opacity = 1, mapProps } = data;
        const { url: newUrl, width: newWdith, height: newHeight } = data.renderProps;
        const { url } = this.props.renderProps;
        if (newUrl !== url || isInit) {
            this._createTexture(newUrl).then(({ texture, ratio, width: realWidth, height: realHeight }) => {
                this.material = new THREE.MeshBasicMaterial({
                    map: texture,
                    side: THREE.FrontSide,
                    transparent: true,
                    depthTest: false,
                    opacity
                });
                if (!newWdith && !newHeight) {
                    this.geometry = new THREE.PlaneGeometry(realWidth, realHeight); // 二维矩形平面
                }
                else if (!newWdith) {
                    this.geometry = new THREE.PlaneGeometry(newHeight * ratio, newHeight); // 二维矩形平面
                }
                else if (!newHeight) {
                    this.geometry = new THREE.PlaneGeometry(newWdith, newWdith / ratio); // 二维矩形平面
                }
                else {
                    this.geometry = new THREE.PlaneGeometry(newWdith, newHeight); // 二维矩形平面
                }
                this.material.opacity = opacity;
            }, () => {
                this.dispose();
            });
        }
        this.visible = visible;
        super.update(data);
    }
    _createTexture(url) {
        return new Promise((resolve, reject) => {
            const loader = new THREE.TextureLoader();
            loader.crossOrigin = 'Anonymous';
            loader.load(url, (texture) => {
                const width = texture.image.width;
                const height = texture.image.height;
                const ratio = width / height;
                // 去除黑边
                texture.minFilter = THREE.NearestFilter;
                texture.magFilter = THREE.NearestFilter;
                texture.needsUpdate = true;
                resolve({ texture, ratio, width, height });
            }, undefined, (err) => { reject(err); });
        });
    }
    dispose() {
        super.dispose();
    }
    onClick() {
        super.onClick();
    }
}
export default Image;
